import React, { useState, useEffect } from "react"
import { Row, Col, Image } from 'antd'
import classes from './styles.module.css'
import ComponentTabs from './components/Tab'
import HelmetComponent from '../../components/Helmet'
import i18next from "i18next"
import { useTranslation } from "react-i18next"
import micon from '../../img/m_icon.png';
import museumBanner from '../../img/museumBanner.png'

const Point: React.FC = () => {
  const controller = new AbortController();
  const { signal } = controller;
  const { t } = useTranslation()

  var currentLanguageCode = i18next.resolvedLanguage;
  
  const pathname = window.location.pathname;
  const pid = pathname.split("/").pop(); 

  const [pointId, setPointId] = useState();
  const [pointName, setPointName] = useState();
  const [PointInfo, setPointInfo] = useState();
  const [Point3d, setPoint3d] = useState();
  const [Point360, setPoint360] = useState();
  const [PointThumb, setPointThumb] = useState(museumBanner);
  const [VoiceMp3, setVoiceMp3] = useState([]);
  const [Bibliography, setPointBibliography] = useState();
  const [Collection, setPointCollection] = useState();
  const [PointGallery, setPointGallery] = useState([]);
  
  // Function to collect data
  const getPoint = async () => {
    const url = `https://dimosapokoronou.mitos.cityguideplatform.com/api/poi?id=${pid}&fetch_files=1&lang=${currentLanguageCode}`
    const response = await fetch(url, 
      { signal, 
        headers: {
          'X-API-KEY': 'OHiqSkWShHTbMGLoB5Am',
          'Content-Type': 'application/json',
          'Accept': 'application/json'}
       })
       if (!response.ok) {
        throw new Error('Data coud not be fetched!')
      } 
    else {
        return response.json()
    }
  };

  useEffect(() => {
    getPoint()
      .then((res) => {
        setPointId(res.success.id)
        setPointName(res.success.name)
        setPointInfo(res.success.portal_main_info)
        setPointBibliography(res.success.bibliographic_citation)
        setPointThumb(res.success.main_image)
        setPointGallery(res.success.files[1])
        setVoiceMp3(res.success.files[4])
        setPoint3d(res.success.files[6][0]["url"])
        setPoint360(res.success.files[1])
      })
      .catch((e) => {
        console.log(e.message)
      })
  },[i18next.language])
  
  const IMAGES:any = []
  const VOICE:any = []

  return (
    <div className={classes.museumContainer}>
      <HelmetComponent title={pointName} descrition={`${pointName} ${t("στην")} ${pointName}` } image={PointThumb} />     

      <div className={classes.headerTitleContainer}>  
        <div className={classes.headerTitle}>
          <span>
            <img src={micon} alt="banner-icon" className={classes.micon}/>
            <h2>{t('Μουσείο')}</h2>
          </span>
          <h2 className={classes.headerText}>{pointName}</h2>
        </div>
        <img className={classes.headerImage} src={PointThumb} alt='museum-banner-img'/>       
      </div>

      <div className={classes.dummy}>
          {PointGallery.map((a4) => (
              IMAGES.push({caption: a4["caption"], url: a4["url"] })
          ))}
        
          {VoiceMp3 && VoiceMp3.map((a4, index) => (
              index == 0 && currentLanguageCode == 'el' && 
              VOICE.push({url: a4["url"] })
          ))}

          {VoiceMp3 && VoiceMp3.map((a4, index) => (
              index == 1 && currentLanguageCode != 'el' && 
              VOICE.push({url: a4["url"] })
          ))}
      </div>

      <div className={classes.tabsContainer}>
        <ComponentTabs Pointid={pointId} Pointinfo={PointInfo} PointThumb={PointThumb} VoiceMp3={VOICE} PointGallery={IMAGES} Bibliography={Bibliography} Point360={Point360} Point3d={Point3d} Collection={Collection}/>
      </div>
    </div>
  )
}

export default Point